<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.invoice.emailed')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">
              <!-- Filters -->
                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('filters')}}</div>
                        <div class="text-right">
                            <b-button variant="primary" size="sm" @click="detailedSearch = !detailedSearch">
                                {{$t('button.detailedSearch')}}</b-button>
                            <b-button variant="default" size="sm" @click="clearSearch()">{{$t('button.resetFilter')}}
                            </b-button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.searchCriteria')}}</label>
                                    <v-select @input="loadPreset" label="name" :options="presetList" v-model="preset">
                                    </v-select>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.invoiceNumber')}}</label>
                                    <input type="text" v-model="search.number" @keyup="searchInvoice"
                                        class="form-control">
                                </div>
                            </div>

                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.studentNo')}}</label>
                                    <input type="number" @keyup="searchInvoice" v-model="search.studentNumber" class="form-control">
                                </div>
                            </div>

                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.fromDate')}}</label>
                                    <date-picker :lang="lang" class="date-picker" v-model="search.fromDeliveryDate" valueType="format"
                                        :format="dateFormat" @change="searchInvoice"
                                        :popup-style="{ top: '100%', left: 0}" :append-to-body="false">
                                    </date-picker>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.toDate')}}</label>
                                    <date-picker :lang="lang" class="date-picker" v-model="search.toDeliveryDate" valueType="format"
                                        :format="dateFormat" @change="searchInvoice"
                                        :popup-style="{ top: '100%', left: 0}" :append-to-body="false">
                                    </date-picker>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="detailedSearch">

                            <div class="col-12">
                                <hr>
                            </div>

                            <div class="col-sm-6">
                                <div class="form-group">
                                    <input type="text" v-model="preset.name" class="form-control"
                                        :placeholder="$t('form.book.presetName')">
                                </div>
                            </div>

                            <div class="col-md-6">
                                <button class="btn btn-primary" @click="savePreset">{{$t('button.save')}}</button>
                                <button class="btn btn-danger" v-show="presetSelected"
                                    @click="deletePreset">{{$t('button.delete')}}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.invoice.emailed')}}</div>
                    </div>
                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover" v-if="notifications.length">
                            <thead>
                                <tr>
                                    <th>{{$t('form.invoice.studentNumber')}}</th>
                                    <th>{{$t('form.invoice.invoiceNumber')}}</th>
                                    <th>{{$t('form.invoice.status')}}</th>
                                    <th>{{$t('form.invoice.send_status')}}</th>
                                    <th>{{$t('form.notification.type')}}</th>
                                    <th>{{$t('form.notification.subject')}}</th>
                                    <th>{{$t('form.notification.processing_timestamp')}}</th>
                                    <th>{{$t('form.notification.delivery_timestamp')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(notify, index) in notifications" :key="index">
                                    <td>
                                        <template v-if="notify.student.length > 0">
                                            <router-link
                                                :to="{name: 'StudentEdit', params: {id: notify.student[0].StudentNumber}}">
                                                {{notify.student[0].StudentNumber}}
                                            </router-link>
                                        </template>
                                    </td>
                                    <td>
                                        <template v-if="notify.InvoiceNumber">
                                            <router-link
                                                :to="{name: 'StudentInvoiceEdit', params: {id: notify.ID}}">
                                                {{notify.InvoiceNumber}}
                                            </router-link>
                                        </template>
                                    </td>
                                    <td v-if="!notify.Status">{{$t('form.invoice.invoice_deleted')}}</td>
                                    <td v-else-if="notify.Status==1">{{$t('form.invoice.status_pending')}}</td>
                                    <td v-else-if="notify.Status==2">{{$t('form.invoice.status_approved')}}</td>
                                    <td v-else-if="notify.Status==3">{{$t('form.invoice.status_sent')}}</td>
                                    <td v-else-if="notify.Status==4">{{$t('form.invoice.status_paid')}}</td>
                                    <td v-else-if="notify.Status==5">{{$t('form.invoice.status_delivery_failed')}}</td>
                                    <td v-else-if="notify.Status==null ||notify.Status==undefined ||invoice.Status==0"></td>
                                    <td>{{notify.SendStatus}}</td>
                                    <td>Invoice</td>
                                    <td>{{notify.EmailSubject}}</td>
                                    <td>{{getTimeStamp(notify.ProcessedAt)}}</td>
                                    <td>{{getTimeStamp(notify.SentAt)}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                    </div>
                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                        @paginate="paginate()">
                    </pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['permissions','dateFormat','datetimeFormat'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,
                presetSelected: false,
                pagination: {
                    current_page: 1
                },

                lang: {
                    formatLocale: {
                        firstDayOfWeek: 1,
                    },
                },

                detailedSearch: false,

                notifications: [],
                search: {
                    number:'',
                    studentNumber:'',
                    fromDeliveryDate:'',
                    toDeliveryDate:''
                },

                preset: {
                    name: '',
                    entity: 'emailedInvoice',
                    value: {}
                },

                presetList: [],
                invoices: [],
            }
        },

        mounted() {

            if (!this.permissions.viewInvoicesStudentsEmailed) {
                return this.$router.push('/');
            }
            if (localStorage.getItem('filter-emailed-invoice')) {
                this.search = JSON.parse(localStorage.getItem('filter-emailed-invoice'));
            }
            this.searchInvoice();
            this.getPresets();
        },
        watch: {
            search: {
                handler(newSearch) {
                    localStorage.setItem('filter-emailed-invoice', JSON.stringify(this.search));

                    const emojiRegex = /[\u{10000}-\u{10FFFF}]/gu;
                    
                    // Loop through all properties in the search object
                    Object.keys(newSearch).forEach(key => {
                    // Only process string values
                    if (typeof newSearch[key] === 'string' && emojiRegex.test(newSearch[key])) {
                        // Strip the emoji and update the reactive property
                        this.search[key] = newSearch[key].replace(emojiRegex, '');
                    }
                    });
                },
                deep: true  
            }
        },
        methods: {
            searchInvoice() {
                this.pagination.current_page = 1;
                this.getNotifications();
            },
            // Save a Preset with Unique Name
            savePreset() {
                this.isLoading = true;
                this.alert = false;

                this.preset.value = JSON.stringify(this.search);

                axios
                    .post('/api/presets', this.preset)
                    .then(response => {
                        this.isLoading = false;
                        this.showAlert(response.data.message);
                        this.getPresets();
                    }, error => {
                        this.isLoading = false;

                        if (error.response.status == 422) {
                            this.showAlert(error.response.data.errors.name[0], 'danger');
                        }
                    });
            },

            // Get Presets in Search Criteria
            getPresets() {
                axios
                    .get('/api/presets/?entity=' + this.preset.entity)
                    .then(response => {
                        this.presetList = response.data;
                    }, error => {
                        console.log(error.response);
                    });
            },

            // Get Search results according to selected Preset Name
            loadPreset() {
                if (!this.preset) {
                    this.preset = {
                        entity: 'emailedInvoice'
                    };
                    this.clearSearch();
                    this.alert = false;
                    this.presetSelected = false;
                    return;
                }
                this.alert = false;
                this.presetSelected = true;
                this.search = JSON.parse(this.preset.value);
                this.searchInvoice();
            },

            // Delete a selected Preset
            deletePreset() {
                let conf = confirm(this.$t('form.validation.delete'));

                if (conf === true) {
                    axios
                        .delete("/api/presets/" + this.preset.id)
                        .then(response => {
                            if (response.data.status == 'success') {
                                this.showAlert(response.data.message);
                                this.getPresets();
                                this.clearSearch();
                                this.preset.name = '';
                                this.preset.value = {};
                                this.presetSelected = false;
                            }
                        })
                        .catch(error => {
                            this.isLoading = false;
                        });
                }
            },
            // Clear search input fields
            clearSearch() {
                this.search = {
                    studentNumber: '',
                    number:'',
                    fromdeliveryDate:'',
                    todeliveryDate:''
                };

                this.searchInvoice();
            },
            getDate(date){
                var dateVar  = date?moment(date).format(this.dateFormat):moment().format(this.dateFormat)
                return dateVar;
            },

            getTimeStamp(timeStamp){
                let res = null;
                if(timeStamp){
                    res = moment(timeStamp).format(this.datetimeFormat)
                }

                return res;

            },

            buildQueryString(obj) {
                let query = '';

                Object.keys(obj).forEach(function (key) {
                    if (obj[key] != '' && obj[key] != null) {
                        query += `${key}=${encodeURIComponent(obj[key])}&`;
                    }
                });

                if (this.pagination && this.pagination.current_page) {
                    query += `page=${this.pagination.current_page}`;
                    return query;
                }

                return query.slice(0, -1);
            },

            getNotifications() {
                this.isLoading = true;
                let filters = this.buildQueryString(this.search);
                axios
                    .get(`/api/invoices?type=student&sentAtIsNotNull=true&${filters}`)
                    .then(response => {
                        if(response.data){
                        this.notifications = response.data.data.data;
                        this.pagination = response.data.pagination;
                        }

                        console.log(this.notifications);
                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            paginate() {
                this.getNotifications();
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    }

</script>
